import yup from '../yup-extended';
import { Phone } from '@cobra/interfaces-enums-mocks/interfaces';

export const mobilePhoneShape = {
    areaCode: yup
        .string()
        .nullable()
        .trim()
        .label('Vorwahl')
        .numeric({ excludeEmptyString: true })
        .mobileAreaCode({ excludeEmptyString: true }),
    cli: yup
        .string()
        .nullable()
        .trim()
        .label('Rufnummer')
        .numeric({ excludeEmptyString: true })
        .optionalMin(7)
        .max(8)
        .notStartsWith('0', { excludeEmptyString: true }),
};
export const mobilePhoneSchema: yup.SchemaOf<Phone> = yup.object(mobilePhoneShape);
export const mobileAreaCodeSchema = mobilePhoneShape.areaCode;
export const mobileCliSchema = mobilePhoneShape.cli;

export const landlinePhoneShape = {
    areaCode: yup
        .string()
        .nullable()
        .trim()
        .label('Vorwahl')
        .numeric({ excludeEmptyString: true })
        .landlineAreaCode({ excludeEmptyString: true }),
    cli: yup
        .string()
        .nullable()
        .trim()
        .label('Rufnummer')
        .numeric({ excludeEmptyString: true })
        .optionalMin(3)
        .max(20)
        .notStartsWith('0', { excludeEmptyString: true }),
};
export const landlinePhoneSchema = yup.object(landlinePhoneShape);
export const landlineAreaCodeSchema = landlinePhoneShape.areaCode;
export const landlineCliSchema = landlinePhoneShape.cli;

const isEmptyPhone = (phone: Phone) => !phone?.areaCode?.trim() && !phone?.cli?.trim();

export const dependentMobileAndLandlinePhoneShape = {
    landlinePhoneNumber: yup.lazy((value) => {
        const requiredLandlinePhoneSchema = yup.object().shape({
            areaCode: landlineAreaCodeSchema.required(),
            cli: landlineCliSchema.required(),
        });

        if (isEmptyPhone(value)) {
            return yup.object().when('mobilePhoneNumber', {
                is: (phone) => isEmptyPhone(phone),
                then: requiredLandlinePhoneSchema,
                otherwise: landlinePhoneSchema,
            });
        }
        return requiredLandlinePhoneSchema;
    }),
    mobilePhoneNumber: yup.lazy((value) => {
        const requiredMobilePhoneSchema = yup.object().shape({
            areaCode: mobileAreaCodeSchema.required(),
            cli: mobileCliSchema.required(),
        });

        if (isEmptyPhone(value)) {
            return yup.object().when('landlinePhoneNumber', {
                is: (phone) => isEmptyPhone(phone),
                then: requiredMobilePhoneSchema,
                otherwise: mobilePhoneSchema,
            });
        }
        return requiredMobilePhoneSchema;
    }),
};
export const dependentMobileAndLandlinePhoneSchema = yup
    .object()
    .shape(dependentMobileAndLandlinePhoneShape, [['landlinePhoneNumber', 'mobilePhoneNumber']]);
